// @flow
import Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../../../../locales/components/namespaces";
import { Update } from "../../../../../../hooks/exhibitions/useExhibitionAction";
import { useDebouncedCallback } from "../../../../../../hooks/useDebouncedCallback";
import ListItemText from "@mui/material/ListItemText";
import { TextField } from "@mui/material";
import ListItem from "@mui/material/ListItem";

type Props = {};

const SendEmailFromName = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const { id, exhibition, updateExhibition, exhibitionIsNotMainOfCoorg } = props
	const onChange = (value) => {
		updateExhibition(id, value, Update.SendFromName)
	}
	const { value, debouncedOnChange } = useDebouncedCallback(onChange, exhibition.sendFromName)
	return (
		<ListItem>
			<ListItemText
				primary={t("Email Sender Name")}
				secondary={
					<React.Fragment>
						{t("Use alternative sender for emails. If field remains empty, default sender name will be used.")}
						{exhibitionIsNotMainOfCoorg && (
							<React.Fragment>
								<br/>
								<Typography
									variant={'body2'}
									color={'error'}
									component={'span'}
								>
									{t('This exhibition is part of a coorganization and not the main coorganization exhibition. As such, Email Sender Name Settings are note applied in Registration Form. For Registration Form visit main coorganization exhibition settings.')}
								</Typography>
							</React.Fragment>
						)}
					</React.Fragment>
				}
			/>
			<TextField
				defaultValue={value}
				onChange={debouncedOnChange}
				size={"small"}
				fullWidth
				variant={'filled'}
				sx={{ minWidth: '200px' }}
				slotProps={{
					htmlInput: {
						maxLength: 250,
						inputMode: 'text'
					},
				}}
			/>
		</ListItem>
	);
};

export default SendEmailFromName